import { ColumnType, MonitoringConfigType } from "../MonitoringPageTypes";

export const DEFAULT_CONFIG: Omit<MonitoringConfigType, "columns"> = {
  RECENT_UPDATE_THRESHOLD_HOURS: 24,
  PAGE_SIZE: 50,
  TOOLTIP_GAP: 12,
  TOOLTIP_MARGIN: 8,
};

export const DEFAULT_COLUMNS: ColumnType[] = [
  { key: "domain", label: "Домен" },
  { key: "category", label: "Категория" },
  {
    key: "nsdi",
    label: "НСДИ",
    // @ts-ignore
    helpTitle: "НСДИ",
    helpText: "Национальная система доменных имен",
  },
  {
    key: "ru",
    label: "RU",
    // @ts-ignore
    helpTitle: "RU",
    helpText: "Негосударственные российские DNS провайдеры",
  },
  {
    key: "global",
    label: "Global",
    // @ts-ignore
    helpTitle: "Global",
    helpText: "Крупные публичные DNS провайдеры, популярные во всём мире",
  },
];

export function getInitialColumnFilters(
  columns: ColumnType[],
): Record<string, string> {
  return columns.reduce((acc, c) => ({ ...acc, [c.key]: "" }), {});
}

export function mergeConfig(
  base: MonitoringConfigType,
  overrides?: Partial<MonitoringConfigType>,
): MonitoringConfigType {
  if (!overrides) return base;
  const merged = { ...base };
  if (overrides.RECENT_UPDATE_THRESHOLD_HOURS != null)
    merged.RECENT_UPDATE_THRESHOLD_HOURS =
      overrides.RECENT_UPDATE_THRESHOLD_HOURS;
  if (overrides.PAGE_SIZE != null) merged.PAGE_SIZE = overrides.PAGE_SIZE;
  if (overrides.TOOLTIP_GAP != null) merged.TOOLTIP_GAP = overrides.TOOLTIP_GAP;
  if (overrides.TOOLTIP_MARGIN != null)
    merged.TOOLTIP_MARGIN = overrides.TOOLTIP_MARGIN;
  if (overrides.columns != null) merged.columns = overrides.columns;
  return merged;
}

export function getEffectiveConfig(
  configOverrides?: Partial<MonitoringConfigType>,
): MonitoringConfigType {
  const base: MonitoringConfigType = {
    ...DEFAULT_CONFIG,
    columns: DEFAULT_COLUMNS,
  };
  return mergeConfig(base, configOverrides);
}

export const config = { ...DEFAULT_CONFIG };
export const INITIAL_COLUMN_FILTERS = getInitialColumnFilters(DEFAULT_COLUMNS);
